/**
 * Menu de l'application. Chaque entrée n'apparaît que si l'utilisateur a une
 * des permissions et si le module est compris dans l'offre de l'entreprise.
 */
export const MENU = [
  { titre: null, liens: [
    { nom: "tableau", libelle: "Tableau de bord", icone: "bi-speedometer2", permissions: ["DASHBOARD"] },
    { nom: "caisse", libelle: "Caisse", icone: "bi-basket2-fill", permissions: ["VENTE_CAISSE"], vedette: true },
  ] },
  { titre: "Ventes", liens: [
    { nom: "ventes", libelle: "Ventes", icone: "bi-receipt", permissions: ["VENTE_CAISSE", "VENTE_VOIR"] },
    { nom: "devis", libelle: "Devis et proformas", icone: "bi-file-earmark-text", permissions: ["DEVIS_GERER"], module: "GROS" },
    { nom: "retours", libelle: "Retours clients", icone: "bi-arrow-counterclockwise", permissions: ["RETOUR_CREER", "VENTE_VOIR"] },
    { nom: "encaissements", libelle: "Encaissements", icone: "bi-cash-coin", permissions: ["VENTE_VOIR", "CAISSE_CONTROLER"] },
    { nom: "clients", libelle: "Clients", icone: "bi-people", permissions: ["CLIENT_VOIR", "CLIENT_GERER", "CLIENT_ENCAISSER"] },
  ] },
  { titre: "Catalogue", liens: [
    { nom: "produits", libelle: "Produits", icone: "bi-box-seam", permissions: ["PRODUIT_VOIR", "PRODUIT_GERER"] },
    { nom: "etiquettes", libelle: "Étiquettes", icone: "bi-upc", permissions: ["PRODUIT_VOIR", "PRODUIT_GERER"] },
    { nom: "categories", libelle: "Catégories et marques", icone: "bi-tags", permissions: ["PRODUIT_GERER"] },
    { nom: "promotions", libelle: "Promotions", icone: "bi-percent", permissions: ["PROMOTION_GERER"], module: "FIDELITE" },
  ] },
  { titre: "Stock", liens: [
    { nom: "stock", libelle: "État du stock", icone: "bi-stack", permissions: ["STOCK_VOIR", "STOCK_AJUSTER"] },
    { nom: "lots", libelle: "Lots et péremptions", icone: "bi-hourglass-split", permissions: ["STOCK_VOIR"] },
    { nom: "mouvements", libelle: "Mouvements", icone: "bi-arrow-left-right", permissions: ["STOCK_VOIR"] },
    { nom: "ajustements", libelle: "Pertes et ajustements", icone: "bi-sliders", permissions: ["STOCK_AJUSTER"] },
    { nom: "inventaires", libelle: "Inventaires", icone: "bi-clipboard-check", permissions: ["INVENTAIRE_GERER", "INVENTAIRE_VALIDER"], module: "STOCK_AVANCE" },
    { nom: "transferts", libelle: "Transferts", icone: "bi-truck", permissions: ["TRANSFERT_GERER", "TRANSFERT_RECEVOIR"], module: "MULTI_SITES" },
  ] },
  { titre: "Achats", liens: [
    { nom: "achats", libelle: "Bons de commande", icone: "bi-cart-check", permissions: ["ACHAT_VOIR", "ACHAT_GERER", "ACHAT_RECEVOIR"], module: "ACHATS" },
    { nom: "fournisseurs", libelle: "Fournisseurs", icone: "bi-building", permissions: ["ACHAT_VOIR", "ACHAT_GERER"], module: "ACHATS" },
  ] },
  { titre: "Finances", liens: [
    { nom: "controle_caisses", libelle: "Contrôle des caisses", icone: "bi-safe", permissions: ["CAISSE_CONTROLER"] },
    { nom: "depenses", libelle: "Dépenses", icone: "bi-wallet2", permissions: ["DEPENSES_VOIR", "DEPENSES_SAISIR", "DEPENSES_VALIDER"], module: "FINANCES" },
    { nom: "analyse", libelle: "Analyse des ventes", icone: "bi-bar-chart-line", permissions: ["RAPPORTS_VOIR"], module: "FINANCES" },
    { nom: "rapports", libelle: "Résultat et trésorerie", icone: "bi-graph-up-arrow", permissions: ["RAPPORTS_VOIR"], module: "FINANCES" },
    { nom: "dettes", libelle: "Dettes et créances", icone: "bi-hourglass", permissions: ["RAPPORTS_VOIR"], module: "FINANCES" },
  ] },
  { titre: "Administration", liens: [
    { nom: "utilisateurs", libelle: "Utilisateurs", icone: "bi-person-badge", permissions: ["ADMIN_LISTE_UTILISATEUR", "ADMIN_CREATION_UTILISATEUR"] },
    { nom: "roles", libelle: "Rôles et droits", icone: "bi-shield-lock", permissions: ["ADMIN_LISTE_ROLE", "ADMIN_CREER_ROLE"] },
    { nom: "parametres", libelle: "Sites et réglages", icone: "bi-gear", permissions: ["PARAMETRES_GERER"] },
    { nom: "entreprise", libelle: "Fiche de l'entreprise", icone: "bi-shop-window", permissions: ["VIEW_CONFIGURATION_SYSTEME", "EDIT_CONFIGURATION_SYSTEME"] },
    { nom: "config_paiement_en_ligne", libelle: "Paiement en ligne", icone: "bi-phone", permissions: ["PAIEMENT_EN_LIGNE_CONFIG"], module: "PAIEMENT_EN_LIGNE" },
    { nom: "mon_abonnement", libelle: "Mon abonnement", icone: "bi-patch-check", permissions: ["ABONNEMENT_GERER", "DONNEES_EXPORTER"] },
    { nom: "journal_activite", libelle: "Journal d'activité", icone: "bi-journal-text", permissions: ["ADMIN_JOURNAL_AUDIT"] },
  ] },
  { titre: "Aide", liens: [
    { nom: "aide", libelle: "Guide d'utilisation", icone: "bi-life-preserver" },
  ] },
];

/** Menu de l'administrateur de la plateforme (aucune donnée commerciale des entreprises). */
export const MENU_PLATEFORME = [
  { titre: null, liens: [
    { nom: "plateforme_revenus", libelle: "Chiffre d'affaires", icone: "bi-graph-up-arrow" },
    { nom: "plateforme_entreprises", libelle: "Entreprises clientes", icone: "bi-buildings" },
    { nom: "plateforme_factures", libelle: "Factures", icone: "bi-receipt" },
    { nom: "plateforme_offres", libelle: "Offres", icone: "bi-boxes" },
    { nom: "plateforme_apporteurs", libelle: "Apporteurs d'affaires", icone: "bi-person-badge" },
    { nom: "plateforme_encaissement", libelle: "Paramètres et inscriptions", icone: "bi-sliders" },
    { nom: "plateforme_emails", libelle: "E-mails", icone: "bi-envelope-at" },
    { nom: "plateforme_supervision", libelle: "Supervision", icone: "bi-activity" },
  ] },
  { titre: "Aide", liens: [
    { nom: "aide", libelle: "Guide d'utilisation", icone: "bi-life-preserver" },
  ] },
];
